module.exports = __webpack_public_path__ + "static/media/completed-dark-blue-2.b47d60cc.svg";